define.alias("shared/utils/analytics/generate-cache-key", "calendar/utils/analytics/generate-cach-key");